import { useCallback, useEffect, useState } from "react";
import adminApi from "../services/adminApi";

export const ADMIN_PROFILE_EVENT = "admin-profile-updated";

const readCachedUser = () => {
  try {
    return JSON.parse(localStorage.getItem("divyayoga_user") || "null") || {};
  } catch {
    return {};
  }
};

const ROLE_LABELS = { superadmin: "Super Admin", admin: "Admin", trainer: "Trainer" };

/**
 * The signed-in admin/staff profile for the dashboard chrome (sidebar, mobile header).
 * Starts from the cached user so the avatar shows instantly, then refreshes from the API.
 * Re-reads whenever the Settings → Profile page dispatches ADMIN_PROFILE_EVENT.
 */
export default function useAdminProfile() {
  const [profile, setProfile] = useState(readCachedUser);

  const refresh = useCallback(async () => {
    try {
      const { data } = await adminApi.getMyProfile();
      if (data) setProfile((prev) => ({ ...prev, ...data }));
    } catch {
      setProfile(readCachedUser());
    }
  }, []);

  useEffect(() => {
    refresh();
    const onUpdate = (e) => {
      if (e?.detail) setProfile((prev) => ({ ...prev, ...e.detail }));
      else refresh();
    };
    window.addEventListener(ADMIN_PROFILE_EVENT, onUpdate);
    return () => window.removeEventListener(ADMIN_PROFILE_EVENT, onUpdate);
  }, [refresh]);

  const name = profile.fullName || profile.name || profile.userName || "Admin User";
  const roleRaw = profile.role || localStorage.getItem("divyayoga_role") || "Admin";
  const role = ROLE_LABELS[String(roleRaw).toLowerCase()] || roleRaw;
  const imageUrl = profile.profileImageUrl || profile.avatarUrl || "";
  const initials = name.split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "AD";

  return { name, role, imageUrl, initials };
}
